export default function PackagesIcon({
  size = 24,
  className = ''
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span className={'flex items-center ' + className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M20.4923 0C22.4259 0 24 1.47654 24 3.49998C24 3.96483 23.8701 4.7158 23.7188 5.12497L20.5 11.9999L17.2813 5.12497C17.1309 4.71678 17 3.96483 17 3.49998C17 1.47654 18.5586 0 20.4923 0ZM20.5001 1.99999C19.6719 1.99999 19.0001 2.67186 19.0001 3.49998C19.0001 4.3281 19.6719 4.99997 20.5001 4.99997C21.3282 4.99997 22.0001 4.3281 22.0001 3.49998C22.0001 2.67186 21.3282 1.99999 20.5001 1.99999ZM4.00784 10.4999C6.21682 10.4999 8.00009 12.2236 8.00009 14.4999C8.00009 15.0224 7.85165 15.8056 7.67979 16.2655L4.00004 24L0.320299 16.2655C0.147447 15.8056 0 15.0233 0 14.4999C0 12.2236 1.79892 10.4999 4.00784 10.4999ZM19.4766 10.9999L19.9453 11.9999H13.7501C12.4952 11.9999 11.5001 12.9951 11.5001 14.2499C11.5001 15.5048 12.4952 16.4999 13.7501 16.4999H16.7501C18.8194 16.4999 20.5001 18.1806 20.5001 20.2499C20.5001 22.3192 18.8194 23.9999 16.7501 23.9999H4.55484L5.03139 22.9999H16.7501C18.2823 22.9999 19.5001 21.7821 19.5001 20.2499C19.5001 18.7177 18.2823 17.4999 16.7501 17.4999H13.7501C11.9581 17.4999 10.5001 16.0419 10.5001 14.2499C10.5001 12.4579 11.9581 10.9999 13.7501 10.9999H19.4766ZM4.00009 12.7499C3.0333 12.7499 2.2501 13.5331 2.2501 14.4999C2.2501 15.4667 3.0333 16.2499 4.00009 16.2499C4.96689 16.2499 5.75009 15.4667 5.75009 14.4999C5.75009 13.5331 4.96689 12.7499 4.00009 12.7499Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}
